import React from 'react'
import { SearchInputOverlay } from 'components'
import { SearchResult, SearchResultSets } from 'components/molecules/Search/Search'
import styles from './SegmentForm.module.scss'

export type TResultSelectData = { result: SearchResult }

type TProps = {
  name: string
  placeholder: string
  heading: string
  resultSets: SearchResultSets
  onResultSelect: (event: React.SyntheticEvent, data: TResultSelectData) => void
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

/** A search box that adds the chosen result to one of the segment form's tables */
const SegmentFormSearch = ({
  name,
  placeholder,
  heading,
  resultSets,
  onResultSelect,
  onSearchChange,
}: TProps): React.ReactElement => (
  <SearchInputOverlay
    name={name}
    placeholder={placeholder}
    className={styles.search}
    icon="add"
    useSearchComponent={true}
    searchComponentProps={{
      isLoading: false,
      resultSets,
      onResultSelect,
      onSearchChange,
      minCharacters: 0,
    }}
  >
    <h2>{heading}</h2>
  </SearchInputOverlay>
)

export default SegmentFormSearch
